import { gql } from "generated-graphql";

export const GET_STAFF_CERS_PRE_POST = gql(/* GraphQL */ `
  query StaffCersPrePost($tenantId: ID) {
    staffCersPrePost(tenantId: $tenantId) {
      facilityWeighted {
        facilitiesAnalyzed
        priorSubmittals
        afterSubmittals
        avgPriorRatePct
        avgAfterRatePct
        avgDeltaPct
        improved
        worsened
        unchanged
      }
      pooled {
        period
        totalSubmittals
        rejectedSubmittals
        facilities
        ratePct
      }
      attribution {
        segment
        totalSubmittals
        rejectedSubmittals
        facilities
        ratePct
      }
      byCupa {
        cupaCode
        displayName
        priorSubmittals
        priorRatePct
        afterSubmittals
        afterRatePct
        deltaPct
      }
      byComplexity {
        bucket
        priorSubmittals
        priorRatePct
        afterSubmittals
        afterRatePct
        deltaPct
      }
      matchRate {
        linkedSubmittals
        totalSubmittals
        pct
        afterLinkedSubmittals
        afterTotalSubmittals
        afterPct
      }
      facilitiesWithCutoff
    }
  }
`);
